import UpdatesCard from "./UpdatesCard";
import MobileAppCard from "./MobileAppCard";
import FAQSection from "../FAQ/FAQSection";
import Social from "../Social/Social";

import {
  DashboardWrapper,
  DashboardGrid,
  DashboardLowerGrid,
  RightColumn,
} from "./Dashboard.styles";
import AICTA from "./AICTA";

const DashboardSection = () => {
  return (
    <DashboardWrapper>
      <DashboardGrid>
        <UpdatesCard />
        <Social />
      </DashboardGrid>

      <DashboardLowerGrid>
        <FAQSection />
        <RightColumn>
          <AICTA />
          <MobileAppCard />
        </RightColumn>
      </DashboardLowerGrid>
    </DashboardWrapper>
  );
};

export default DashboardSection;
